import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 380,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

const ItrModal = ({ open, setOpen, onInterest }) => {
  const handleClose = () => setOpen(false);

  const handleInterest = () => {
    if (onInterest) onInterest();
    alert("Thank you for your interest in ITR services!");
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <InsertDriveFileOutlinedIcon color="primary" />
            <Typography variant="h6" fontWeight="bold">
              ITR Filing Service
            </Typography>
          </Box>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Content */}
        <Typography variant="body1" gutterBottom>
          <strong>Dillipay Technologies Limited</strong> launched a convenient service for filing <strong>INDIVIDUAL ITR</strong>.
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          <strong>Normal ITR:</strong> ₹499 (starting price)
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          <strong>Contact:</strong> +91 9355128199<br />
          <strong>Email:</strong> support@dillipay.com
        </Typography>

        {/* CTA Button */}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleInterest}
          sx={{ mt: 3, py: 1 }}
        >
          I am Interested
        </Button>
      </Box>
    </Modal>
  );
};

export default ItrModal;
